import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared';
import { ToolsPageComponent } from './tools/page/tools-page.component';
import { AdminPageComponent } from './admin/page/admin-page.component';
import { SrcSetModule } from '@skyeng/libs/shared/src-set';
import { DsIconModule } from '@skyeng/libs/shared/ui-kit-v2/icon';

@NgModule({
  imports: [SharedModule, RouterModule, SrcSetModule, DsIconModule],
  declarations: [AdminPageComponent, ToolsPageComponent],
  exports: [AdminPageComponent, ToolsPageComponent],
  providers: [],
})
export class SharedLayoutModule {}
